import { api } from '@/lib/api'
import type {
  ApprovalCatalog,
  ApprovalDelegation,
  ApprovalDelegationPayload,
  ApprovalInboxItem,
  ApprovalInboxSummary,
  ApprovalInstance,
  ApprovalInstanceDetail,
  ApprovalPolicy,
  ApprovalPolicyPayload,
} from './types'

export const approvalsApi = {
  // Policies
  listPolicies: (params?: { resource_type?: string; active_only?: boolean }) => {
    const qs = new URLSearchParams()
    if (params?.resource_type) qs.set('resource_type', params.resource_type)
    if (params?.active_only) qs.set('active_only', 'true')
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return api.get<{ policies: ApprovalPolicy[] }>(`/api/approvals/policies${suffix}`)
  },
  getPolicy: (id: number) =>
    api.get<{ policy: ApprovalPolicy }>(`/api/approvals/policies/${id}`),
  createPolicy: (body: ApprovalPolicyPayload) =>
    api.post<{ policy: ApprovalPolicy }>('/api/approvals/policies', body),
  updatePolicy: (id: number, body: Partial<ApprovalPolicyPayload>) =>
    api.put<{ policy: ApprovalPolicy }>(`/api/approvals/policies/${id}`, body),
  deletePolicy: (id: number) =>
    api.del<{ deactivated: boolean }>(`/api/approvals/policies/${id}`),
  catalog: () => api.get<ApprovalCatalog>('/api/approvals/policies/catalog'),

  // Instances
  listInstances: (params?: { status?: string; resource_type?: string }) => {
    const qs = new URLSearchParams()
    if (params?.status) qs.set('status', params.status)
    if (params?.resource_type) qs.set('resource_type', params.resource_type)
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return api.get<{ instances: ApprovalInstance[] }>(`/api/approvals/instances${suffix}`)
  },
  getInstance: (id: number) =>
    api.get<{ instance: ApprovalInstanceDetail }>(`/api/approvals/instances/${id}`),
  act: (id: number, body: { action: 'approve' | 'reject' | 'comment' | 'cancel'; comment?: string; metadata?: Record<string, unknown> }) =>
    api.post<{ instance: ApprovalInstanceDetail }>(`/api/approvals/instances/${id}/act`, body),

  // Inbox
  inbox: (params?: { limit?: number; offset?: number }) => {
    const qs = new URLSearchParams()
    if (params?.limit != null) qs.set('limit', String(params.limit))
    if (params?.offset != null) qs.set('offset', String(params.offset))
    const tail = qs.toString() ? `?${qs.toString()}` : ''
    return api.get<{ items: ApprovalInboxItem[]; limit: number; offset: number; total: number }>(
      `/api/approvals/inbox${tail}`,
    )
  },
  inboxSummary: () => api.get<ApprovalInboxSummary>('/api/approvals/inbox/summary'),

  // Delegations (Phase 3c)
  listDelegations: () => api.get<{ delegations: ApprovalDelegation[] }>('/api/approvals/delegations'),
  createDelegation: (body: ApprovalDelegationPayload) =>
    api.post<{ delegation: ApprovalDelegation }>('/api/approvals/delegations', body),
  revokeDelegation: (id: number) =>
    api.del<{ delegation: ApprovalDelegation }>(`/api/approvals/delegations/${id}`),
}
